import { BaseSelectors } from '@makemydeal/dr-activities-common';
import type { IDxgVehicle } from '@makemydeal/dr-shared-types';

import type { IAdditionalSelectors } from '../types/IAdditionalSelectors';
import type { IOpenDeal } from '../types/IOpenDeal';
import type { HostEnvironment } from '@makemydeal/dr-shared-ui-utils';
import type { Dealership } from '@makemydeal/dr-activities-dealership-picker';
import type { IncompleteDealDetails, IShopper } from '@makemydeal/dr-platform-types';

export class Selectors extends BaseSelectors {
    constructor(public sliceName: string, public additionalSelectors: IAdditionalSelectors) {
        super(sliceName);
    }

    /**
     * Get the slice of state for this activity
     * @param state Entire State Tree
     */
    getState = (state: any): IOpenDeal => {
        return super.getState(state);
    };

    getConsumerValidState = (state: any): boolean | undefined => {
        return this.getState(state).isConsumerValid;
    };

    getDealers = (state: any): Array<Dealership> => {
        return state.dealershipPicker?.dealerships || [];
    };

    getSelectedDealer = (state: any) => {
        return this.getState(state).selectedDealer;
    };

    getCommonOrgId = (state: any): string => {
        return this.getState(state).commonOrgId || '';
    };

    getSelectedVehicle = (state: any): IDxgVehicle | undefined => {
        return this.getState(state).selectedVehicle;
    };

    getVehicleVin = (state: any) => {
        return { search: this.getSelectedVehicle(state)?.vin };
    };

    getInitialPageSize = () => {
        return 10;
    };

    getSelectedConsumer = (state: any): IShopper => {
        return this.getState(state).selectedConsumer as IShopper;
    };

    getIsChangeVehicleEditView = (state: any): boolean => {
        return this.getState(state).isChangeVehicleEditView || false;
    };

    isOpeningDeal = (state: any): boolean => {
        return !!this.getState(state).isOpeningDeal;
    };

    isUpdateDealFailure = (state: any): boolean => {
        return !!this.getState(state).isUpdateDealFailure;
    };

    isDealModified = (state: any): boolean => {
        return !!this.getState(state).isDealModified;
    };

    getEnvironment = (state: any): HostEnvironment | undefined => {
        return this.getState(state).environment;
    };

    getErrorMessage = (state: any): string | undefined => {
        return this.getState(state).errorMessage;
    };

    getSaveDealStatus = (state: any): string | undefined => {
        return this.getState(state).saveDealStatus;
    };

    getIsDealSaveInProgress = (state: any): boolean => {
        return this.getState(state).isDealSaveInProgress;
    };

    getIsSyncConsumerData = (state: any): boolean => {
        return this.getState(state).syncConsumerData || false;
    };

    getIncompleteDealDetails = (state: any): IncompleteDealDetails | undefined => {
        return state.dealValidation;
    };
}
